
export const Types = {
    START_UPLOAD_LOCATIONS: "START_UPLOAD_LOCATIONS",
    END_UPLOAD_LOCATIONS: "END_UPLOAD_LOCATIONS",
    UPLOAD_LOCATIONS: "UPLOAD_LOCATIONS",
    UPLOADED_LOCATIONS: "UPLOADED_LOCATIONS",
    GET_LOCATION_FILE: "GET_LOCATION_FILE",
    RECEIVED_LOCATION_FILE: "RECEIVED_LOCATION_FILE",
    REMOVE_LOCATION_FILE: "REMOVE_LOCATION_FILE"
};

export const startUploadLocationsAction = (brk, resourcePath, fieldPath) => ({
    type: Types.START_UPLOAD_LOCATIONS,
    brk: brk,
    resourcePath: resourcePath,
    fieldPath: fieldPath
});

export const endUploadLocationsAction = () => ({
    type: Types.END_UPLOAD_LOCATIONS
});

export const uploadLocationsAction = (file) => ({
    type: Types.UPLOAD_LOCATIONS,
    file: file
});

export const uploadedLocationsAction = (upload) => ({
    type: Types.UPLOADED_LOCATIONS,
    upload: upload
});

export const getLocationFileAction = (breakId, stepId) => ({
    type: Types.GET_LOCATION_FILE,
    breakId: breakId,
    stepId: stepId
});

export const receivedLocationFile = (items) => ({
    type: Types.RECEIVED_LOCATION_FILE,
    items: items
});

export const removeLocationFileAction = (file, rootResource, resourcePath, fieldPath) => ({
    type: Types.REMOVE_LOCATION_FILE,
    file: file,
    rootResource: rootResource,
    resourcePath: resourcePath,
    fieldPath: fieldPath
});



// WEBPACK FOOTER //
// ./public/pages/StoreFinderImport/actions.js